import { styled } from '@slal/ui';
import { ButtonGroup } from '../Button';

export const NavigationButtonGroup = styled(ButtonGroup)`
    padding-top: 32px;
`;
